import type {
  DegreeHomePageContent_PageContentPartnerInformationFragment as PageContentPartnerInformation,
  DegreeHomePageContent_PremiumCertificatePageContentFragment as PremiumCertificatePageContent,
  DegreeHomePageContent_UniversityProgramPageContentFragment as UniversityProgramPageContent,
} from 'bundles/degree-home/__generated__/contentfulTypes';

export const convertUniversityProgramPageContentToGenericPageContent = (
  content: UniversityProgramPageContent
): PageContent => {
  return Object.assign({}, content, { name: content.programName });
};

export const convertPremiumCertificatePageContentToGenericPageContent = (
  content: PremiumCertificatePageContent
): PageContent => {
  return Object.assign({}, content, { name: content.certificateName });
};

export type PageContent = {
  name?: string | null;
  partnerInformation?: PageContentPartnerInformation | null;
};
